import * as React from 'react';
const SVGComponent = (props) => (
  <svg
    width={29}
    height={29}
    viewBox='0 0 29 29'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='m14.5 23.748-.916-.827q-2.958-2.703-4.893-4.626Q6.755 16.37 5.635 14.9T4.07 12.24a6.8 6.8 0 0 1-.445-2.393q0-2.306 1.566-3.872T9.063 4.41q1.594 0 2.99.816T14.5 7.598q1.05-1.557 2.447-2.372a5.83 5.83 0 0 1 2.99-.816q2.306 0 3.872 1.566t1.566 3.872q0 1.203-.445 2.393t-1.565 2.66-3.044 3.393q-1.925 1.924-4.905 4.627zm0-1.636q2.9-2.62 4.773-4.49t2.96-3.244q1.088-1.375 1.51-2.435a5.6 5.6 0 0 0 .424-2.095q0-1.813-1.209-3.021-1.208-1.209-3.02-1.209-1.443 0-2.663.824-1.22.825-2.185 2.48h-1.18q-.988-1.68-2.196-2.492a4.66 4.66 0 0 0-2.652-.812q-1.788 0-3.009 1.209-1.22 1.208-1.22 3.02 0 1.034.423 2.096.424 1.06 1.51 2.435 1.088 1.374 2.961 3.232 1.874 1.859 4.773 4.502'
      fill='#fff'
    />
    <path
      d='M22 14.917 14.5 22 10 18.222l-3.5-3.305-1.5-4.25.5-3.306 2-1.417h4l3 2.362 1-.945 2-1.417L21 5l3 2.361v3.778z'
      fill='#fff'
      stroke='#fff'
    />
  </svg>
);
export default SVGComponent;
